module.exports = __webpack_public_path__ + "static/assets/f1f767c70b08089a3940f35ebfdc315e.png";